import { Variant } from 'react-bootstrap/esm/types';
import { NoteEntity } from 'v2/models';

export const mapNoteSeverity = (severity: NoteEntity['severity']): Variant => {
  switch (severity) {
    case 'info':
      return 'primary';

    default:
      return severity;
  }
};
